import { Box, Flex } from '@/ui';
import { SECTION_COUNT } from './steps';

type Props = {
  sectionIndex: number;
};

export const StepProgress = ({ sectionIndex }: Props) => (
  <Flex gap={1}>
    {Array.from({ length: SECTION_COUNT }, (_, index) => (
      <Box
        bg={index <= sectionIndex ? 'magicPurple.500' : 'blackAlpha.200'}
        borderRadius="ah-pill"
        h={1}
        key={index}
        transition="background-color 0.2s ease"
        w={index === sectionIndex ? 5 : 3}
      />
    ))}
  </Flex>
);
